var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeparationLineGreenBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a5840f49-9615-4b0f-912d-3fb211d54eb9{fill:#0fc571;}.e780205d-dfb4-4e24-a09c-d3c11fa6471d{fill:#33aac6;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a3655f1a-bf69-4ac1-a9b1-fda271cf2727",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b061785b-90d3-442f-a373-ca519fcd217a",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b65e5ccc-dbf5-4fae-aac1-1bec3bfc38c8",
    "data-name": "Rounded Rectangle 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b83c7ae0-9b0c-404a-be31-08b71f4295d9",
    "data-name": "Rounded Rectangle 3-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a5840f49-9615-4b0f-912d-3fb211d54eb9",
    d: "M107,0H2A2,2,0,0,0,2,4H107a2,2,0,0,0,0-4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ac69e6a3-1a0d-4d6d-b27a-35e47a30e26d",
    "data-name": "Rounded Rectangle 3 copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a93f7f84-f9b6-402b-8e33-34e8a33ab624",
    "data-name": "Rounded Rectangle 3 copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e780205d-dfb4-4e24-a09c-d3c11fa6471d",
    d: "M148,0H123a2,2,0,0,0,0,4h25a2,2,0,0,0,0-4Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparationLineGreenBlue);
export default __webpack_public_path__ + "static/media/separation-line-green-blue.543e846c16ecc5e4cf6b02ed071b05d3.svg";
export { ForwardRef as ReactComponent };